module.exports = __webpack_public_path__ + "static/assets/1c6bb07121b82bb055f9e7c3f85a16fd.png";